// extracted by mini-css-extract-plugin
module.exports = {"dragFile":"FileDragAndDrop_dragFile__32XuB"};